import { useEffect } from "react";
import { Link } from "react-router-dom";
function Company() {
    useEffect(() => {
    window.scrollTo(0, 0);
    }, []);
  return (
    <div className="page">
      <div className="sub company">
        <div className="visual">
          <div className="dimBg2"></div>
          <div className="container">
            <div className="text">
              언제나 함께 하는 사람들
              <br />
              KNO1996입니다.
            </div>
          </div>
        </div>
        <div className="container">
        <div className="subPageTitle">
        회사소개
        </div>
          <div className="expWrap">
            <div className="item">
              <div class="title">KNO1996: 혁신과 신뢰로 시작된 디지털 여정</div>
              <div class="content">
                2025년 설립된 KNO1996은{" "}
                <strong>"기술로 세상을 연결하고 미래를 혁신한다"</strong>는
                사명을 가지고 IT 업계에 첫 발을 내디뎠습니다. 비록 짧은
                시간이지만, 우리는 최신 기술과 혁신적인 접근 방식을 바탕으로
                빠르게 성장하며 고객과 시장으로부터 높은 신뢰를 얻고 있습니다.
                우리의 목표는 단순히 기술을 제공하는 것을 넘어,{" "}
                <strong>미래를 설계하고 새로운 가치를 창출하는 것</strong>
                입니다.
              </div>
            </div>

            <div className="item">
              <div class="title">우리의 미션과 비전</div>
              <div class="content">
                <strong>미션:</strong> KNO1996은 디지털 솔루션을 통해 고객의
                비즈니스를 혁신하고, 모든 산업에 가치를 더하는 것을 목표로
                합니다.
                <br />
                <strong>비전:</strong> 고객의 성공을 우리의 성공으로 여기는
                파트너십 정신을 바탕으로, IT의 새로운 기준을 세웁니다.
              </div>
            </div>

            <div className="item">
              <div class="title">전문화된 서비스</div>
              <div class="content">
                KNO1996은 설립 초기부터 각 분야의 전문가들이 모여 완벽한
                솔루션을 제공합니다. 주요 서비스는 다음과 같습니다:
              </div>
              <div class="content">
                - 소프트웨어 개발 및 컨설팅: 고객의 요구에 맞춘 맞춤형
                애플리케이션과 시스템 구축.
                <br />
                - 클라우드 서비스: 안정적이고 유연한 클라우드 환경 설계 및 구축.
                <br />
                - 데이터 분석 및 AI: 데이터 기반의 통찰력을 제공하고, AI 기술로
                효율성을 극대화합니다.
                <br />- 디지털 전환: 기업의 전통적인 프로세스를 디지털로
                혁신하여 생산성과 경쟁력을 강화합니다.
              </div>
            </div>

            <div className="item">
              <div class="title">신뢰받는 파트너</div>
              <div class="content">
                짧은 설립 역사에도 불구하고 KNO1996은{" "}
                <strong>"고객 중심"</strong> 철학을 바탕으로 한 프로젝트를 통해
                신뢰받는 파트너로 자리 잡고 있습니다. 우리는 고객과의 협력을
                통해 최상의 결과를 도출하며, 고객의 성공이 곧 우리의 목표임을
                명확히 합니다.
              </div>
            </div>

            <div className="item">
              <div class="title">최신 기술과 트렌드에 기반한 솔루션</div>
              <div class="content">
                KNO1996은 항상 최신 기술과 트렌드에 발맞춰 움직입니다. 빠르게
                변화하는 IT 환경에서 우리는 유연성과 전문성을 바탕으로 시장의
                요구를 선도합니다.
              </div>
              <div class="content">
                - 최신 클라우드 기술 도입
                <br />
                - 인공지능 기반의 비즈니스 솔루션
                <br />- IoT 및 빅데이터 기술로 스마트한 비즈니스 환경 구현
              </div>
            </div>

            <div className="item">
              <div class="title">지속 가능한 미래를 위한 노력</div>
              <div class="content">
                KNO1996은 기술 혁신과 함께 지속 가능성을 중요시합니다. 우리는
                환경 친화적인 기술을 채택하고, 사회적 책임을 다하는 기업으로
                자리매김하고자 노력합니다. 우리의 목표는 단순히 경제적 성과를
                넘어, 사회와 환경에 긍정적인 영향을 미치는 것입니다.
              </div>
            </div>

            <div className="item">
              <div class="title">함께하는 성장</div>
              <div class="content">
                KNO1996은 여러분과 함께 성장하고 싶습니다. 우리의 열정과 기술은
                고객의 비전을 실현하는 데 초점을 맞춥니다. 함께 미래를 만들어갈
                준비가 되셨나요? 지금 KNO1996과 함께하세요.
              </div>

              <div class="content">
                2025년의 작은 시작은 고객과 함께하는 내일의 거대한 도약이 될
                것입니다.
                <br />
                <strong>"KNO1996과 함께, 가능성은 무한합니다."</strong>
              </div>
            </div>
          </div>
          <div className="infoWrap">
            <div className="title">
              회사 정보
            </div>
            <div className='item'>
              <span className="key">
                주소
              </span>
              <span className="value">
              경기 용인시 처인구 모현읍 오산리 343-32(경기 용인시 처인구 모현읍 오산로 186-2)
              </span>
              </div>
              <div className='item'>
              <span className="key">
                전화
              </span>
              <span className="value">
                031-338-5542
              </span>
              </div>
              <div className='item'>
              <span className="key">
                팩스
              </span>
              <span className="value">
                031-338-5541
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Company;
